/**
 * Created by takeo on 2016/10/06.
 */
import 'intro.js';
import '../../source/javascripts/ace/ace-extra';
import './ui/legacy/inquiry';



// WEBPACK FOOTER //
// ./es6/user-common-js/header.js